<template>
  <div class="q-pa-md">
    <q-spinner-gears
      v-if="loadingData"
      color="primary"
      size="4em"
      class="absolute-center"
    />
    <div v-else>
      <q-form ref="myForm">
        <div class="well well-sm">
          <div class="panel">          
            <div class="q-pa-md">
              <div style="display: flex; align-items: center; margin-bottom: 15px">
                <div
                  v-bind:class="{
                    column: $q.platform.is.mobile,
                    row: $q.platform.is.desktop,
                  }"
                >
                  <span class="text__title--medium">Pontaj prezenta</span>
                </div>
              </div>

              <div style="display: flex;align-items: start;">
                <div style="width: 65%; display: flex; flex-direction: row;">
                  <div style="display: flex;flex-direction: column;width: 100%;">
                    <div class="row">
                      <span class="col-4 form__label">Id</span>
                      <span class="col-8 form__label__black">{{prezenta.id}}</span>
                    </div>

                    <div class="row">
                      <span class="col-4 form__label">Tipul de pontaj</span>
                      <span class="col-8 form__label__black">{{prezenta.tip_pontaj_prezenta}}</span>
                    </div>

                    <div class="row">
                      <span class="col-4 form__label">Nume prenume</span>
                      <span class="col-8 form__label__black">{{prezenta.user_id?.last_name + ' ' + prezenta.user_id?.first_name}}</span>
                    </div>

                    <div class="row">
                      <span class="col-4 form__label">Descriere</span>
                      <span class="col-8 form__label__black">{{prezenta.descriere}}</span>              
                    </div>

                    <div class="row">
                      <span class="col-4 form__label">La data</span>
                      <span class="col-8 form__label__black">{{prezenta.pontaj_date}}</span>              
                    </div>

                    <div class="row">
                      <span class="col-4 form__label">Ore pontate</span>
                      <span class="col-8 form__label__black">{{prezenta.efort}}</span>
                    </div>
                  </div>
                </div>
                
                <!--prezenta.appid_tip_pontaj_prezenta == 1 => 'TeleMunca' -->
                <div v-if="prezenta.appid_tip_pontaj_prezenta?.appid == 1 && prezenta.id !== 0"
                  style="width: 35%; display: flex; flex-direction: row; justify-content: center; align-items:center;">
                  <div style="display: flex; flex-direction: column">
                    <div 
                        v-bind:class="{
                        column: $q.platform.is.mobile,
                        row: $q.platform.is.desktop,
                        }"
                    >
                      <div style="display: flex;align-items: center;justify-content: center;width: 100%;">
                        <div>
                          <span class="text__title--medium">Documente atasate</span>
                          <div
                              v-show="
                                  prezenta.scan_documents != null &&
                                  prezenta.scan_documents.length == 0 &&
                                  !uploadingFileToServer
                              "
                              class="text__label--thin"
                              style="width: 100%; text-align: center"
                          >
                            Nimic atasat
                          </div>
                        </div>
                        <!-- <div v-if="user.auth_for_upload_scan == 'y'">
                          <q-btn 
                            flat
                            color="primary"
                            icon="add_box"
                            no-caps
                            size="lg"
                            :disable="loadingData"
                            @click="openFormUploadFile"
                            v-if="deplasare.stare === 'initiat'"                            
                          >
                            <q-tooltip
                              transition-show="rotate"
                              transition-hide="rotate"
                            >
                              Incarca document nou
                            </q-tooltip>
                          </q-btn>
                        </div> -->
                      </div>

                      <div style="display: flex;align-items: center;justify-content: center;width: 100%;">
                        <div>
                          <q-spinner
                            v-if="uploadingFileToServer"
                            color="primary"
                            size="3em"
                            :thickness="10"
                          />
                          <table
                            v-else
                            class="table table-bordered table-condensed table-responsive"
                            style="width: 100%; max-height: 50vh"
                          >
                            <tbody>
                              <tr
                                  v-for="scan in prezenta.scan_documents"
                                  v-bind:key="scan.appid"
                              >
                                <!-- v-if="user.is_admin == 'y'" -->
                                <!-- <td v-if="deplasare.stare === 'initiat'">                                  
                                  <span                                    
                                    class="material-icons cursor-pointer"
                                    style="color: red; font-size: 1.3rem;"
                                    @click="askIfRemoveScan(scan)"
                                    >delete_forever</span
                                  >
                                </td> -->
                                <td>
                                  {{ scan.file_ext }}
                                </td>
                                <td>
                                  {{ humanReadableBytes(scan.file_size) }}
                                </td>
                                <td>
                                  <div class="desktop-only" style="max-width: 30vw">
                                    {{ scan.description }}
                                  </div>
                                  <div class="mobile-only">
                                      {{ scan.description }}
                                  </div>
                                </td>
                                <td>
                                  <q-btn
                                    round
                                    color="black"
                                    icon="cloud_download"
                                    size="xs"
                                  />
                                  <q-menu
                                    fit
                                    transition-show="scale"
                                    transition-hide="scale"
                                  >
                                    <DialogOpenScan :appid="scan.appid" type_scan="PontajPrezenta"/>
                                  </q-menu>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div clas="row" style="margin-top: 5px;margin-bottom: 15px;" v-if="prezenta.stare !== 'initiat'">
                <TaskList :appid="appid" :task="task" :onState="onState" :isSuccess="isSuccess"/>
            </div>
          </div>      
        </div>
      </q-form>
    </div>
  </div>
</template>

<script lang="ts" src="./EditPontajPrezentaDetail.ts" />

<style scoped>
.q-field--with-bottom {
  padding-bottom: 20px;
}

.q-field__native {
  font-family: "Nunito Sans";
  font-weight: bolder;
}
</style>